import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faCheckCircle,
  faExclamationTriangle
} from '@fortawesome/pro-light-svg-icons'

export const statusClassNames = {
  error: 'is-error',
  warning: 'is-warning',
  success: 'is-success'
}

export type FieldState = keyof typeof statusClassNames

export type FieldStateIcon = Record<FieldState, IconDefinition>

export const icons: FieldStateIcon = {
  success: faCheckCircle,
  error: faExclamationTriangle,
  warning: faExclamationTriangle
}
